moment = require("moment")
class ISODateDirective
  @$inject: []
  constructor: ()->
    class ISODate    
      restrict: "A"
      require: "ngModel"
      link: (scope, element, attrs, $ctrl)->
        console.log 'f'
        # $ctrl.$parsers.push (val)->
        #   console.log val
        #   return new Date()
        $ctrl.$formatters.push (val)-> 
          console.log val 
          if val        
            return new Date(val)          
          return null
        
    return new ISODate()
module.exports = ISODateDirective


// WEBPACK FOOTER //
// ./src/common/editor/fields/iso.coffee